export const maskCardNumber = (lastFourDigits: string): string =>
  `\u2022\u2022${lastFourDigits}`
